<template>
  <div>
    <the-nav-bar :title="$t('createPost.standardHours')" />
    <div class="body-wrapper">
      <div class="body-header">
        <p class="strong text">{{ $t('customize.standardHoursTitle') }}</p>
        <p class="text">
          {{ $t('customize.standardHoursSubtitle') }}
        </p>
      </div>
      <div class="body-content field">
        <div
          class="field-item row-justify-center"
          @click="showPopup('timeZone')"
        >
          <div class="field-item-title">{{ $t('customize.timeZone') }}</div>
          <div
            class="field-item-content"
            :class="{ inactive: timeObj.timeZone === '' }"
          >
            {{
              timeObj.timeZone === '' || !timeZoneList[timeObj.timeZone]
                ? $t('createPost.default')
                : timeZoneList[timeObj.timeZone].text
            }}
          </div>
          <div class="field-item-right">
            <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
          </div>
        </div>
        <div
          class="field-item row-justify-center"
          @click="showPopup('timeStart')"
        >
          <div class="field-item-title">{{ $t('customize.timeStart') }}</div>
          <div
            class="field-item-content"
            :class="{ inactive: timeObj.timeStart === '' }"
          >
            {{
              timeObj.timeStart === '' || !timeStartList[timeObj.timeStart]
                ? $t('createPost.default')
                : timeStartList[timeObj.timeStart].text
            }}
          </div>
          <div class="field-item-right">
            <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
          </div>
        </div>
        <div
          class="field-item row-justify-center"
          @click="showPopup('timeEnd')"
        >
          <div class="field-item-title">{{ $t('customize.timeEnd') }}</div>
          <div
            class="field-item-content"
            :class="{ inactive: timeObj.timeEnd === '' }"
          >
            {{
              timeObj.timeEnd === '' || !timeEndList[timeObj.timeEnd]
                ? $t('createPost.default')
                : timeEndList[timeObj.timeEnd].text
            }}
          </div>
          <div class="field-item-right">
            <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
          </div>
        </div>
      </div>
      <div class="body-footer">
        <md-button
          :type="isBtnDisabled ? 'disabled' : 'primary'"
          @click="onConfrimBtnClick"
        >
          <span>{{ $t('common.confirm') }}</span>
        </md-button>
      </div>
    </div>
    <md-popup v-model="isShowPopup" position="bottom" class="popup">
      <md-popup-title-bar
        only-close
        large-radius
        class="title-bar"
        :title="popupData.title"
        @confirm="hidePopup"
        @cancel="hidePopup"
      />
      <md-scroll-view :scrolling-x="false" auto-reflow class="popup-body">
        <div
          class="popup-item row-center"
          v-for="(item, index) in popupData.list"
          :key="`popup-item-${popupData.name}-${index}`"
          @click="onChoose(index)"
          :class="{ active: index === popupData.value }"
        >
          <div class="text">{{ item.text }}</div>
        </div>
      </md-scroll-view>
    </md-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TheNavBar from '@/components/the-nav-bar';
import { Icon, Button, PopupTitleBar, Popup, ScrollView } from 'mand-mobile';
export default {
  components: {
    'the-nav-bar': TheNavBar,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [ScrollView.name]: ScrollView,
  },
  data() {
    return {
      isShowPopup: false,
      timeObj: {
        timeZone: '',
        timeStart: '',
        timeEnd: '',
      },
      popupData: {
        name: '',
        title: '',
        value: '',
        list: [],
      },
      isSubmitting: false,
    };
  },
  computed: mapState({
    adTemp: state => state.adTemp,
    timeList: state => state.settings.timeList,
    timeZoneList: state =>
      state.settings.timeZoneList.map(item => {
        const timeZone = -(new Date().getTimezoneOffset() / 60);
        return {
          value: item.value,
          originText: item.text,
          text: timeZone == item.value ? `${item.text} (suggested)` : item.text,
        };
      }),
    timeStartList() {
      return this.timeList.slice(0, 24);
    },
    timeEndList() {
      return this.timeList.slice(1);
    },
    isBtnDisabled() {
      const temp = this.timeObj;
      let disabled = false;
      for (let k in this.timeObj) {
        if (temp.hasOwnProperty(k) && temp[k] === '') {
          disabled = true;
        }
      }
      if (temp.timeStart >= temp.timeEnd + 1) {
        disabled = true;
      }
      return disabled || this.isSubmitting;
    },
  }),
  created() {
    const { timeZone, timeStart, timeEnd } = this.adTemp;
    if (timeZone !== '') {
      this.timeObj.timeZone = timeZone;
    } else {
      this.timeObj.timeZone = -(new Date().getTimezoneOffset() / 60) + 12;
    }
    if (timeStart !== '') {
      this.timeObj.timeStart = timeStart;
    }
    if (timeEnd !== '' && timeEnd > 0) {
      this.timeObj.timeEnd = timeEnd - 1;
    }
  },
  methods: {
    showPopup(name) {
      this.popupData.name = name;
      this.popupData.value = this.timeObj[name];
      this.popupData.title = this.$t(`customize.${name}`);
      switch (name) {
        case 'timeZone':
          this.popupData.list = this.timeZoneList;
          break;
        case 'timeStart':
          this.popupData.list = this.timeStartList;
          break;
        case 'timeEnd':
          this.popupData.list = this.timeEndList;
          break;
      }
      this.$nextTick(() => {
        this.isShowPopup = true;
      });
    },
    hidePopup() {
      this.isShowPopup = false;
    },
    onChoose(index) {
      if (this.timeObj[this.popupData.name] === index) return;
      this.timeObj[this.popupData.name] = index;
      this.$nextTick(() => {
        this.hidePopup();
      });
    },
    onConfrimBtnClick() {
      this.isSubmitting = true;
      let { timeZone, timeStart, timeEnd } = this.timeObj;
      timeEnd += 1;
      this.$store.commit('setCreateTemp', {
        timeZone,
        timeStart,
        timeEnd,
      });
      this.$nextTick(() => {
        this.isSubmitting = false;
        this.$router.back();
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding: 9.6vw 0 30vw;
}

.body-header {
  margin: 0 4.8vw;
  color: #84969c;

  .text {
    margin-bottom: 4.8vw;
  }

  .strong {
    font-size: 3.73vw;
    color: color-text-base;
  }
}

.body-content {
  .field-item {
    height: 17.07vw;
    padding: 0 4.8vw;
    font-size: 3.73vw;

    &:nth-child(even) {
      background: #f8fBfc;
    }
  }

  .field-item-title {
    flex: 0 0 32vw;
    font-weight: bold;
  }

  .field-item-content {
    flex: 1 0 0;
    text-align: right;
    color: color-primary;

    &.inactive {
      color: #BCC7CB;
    }
  }

  .field-item-right {
    margin-left: 1.07vw;
  }
}

.body-footer {
  margin: 9.6vw 4.8vw;
}

.popup {
  .title-bar {
    border-bottom: 0.27vw solid #eaf1f3;

    >>> .title-bar-left, >>> .title-bar-right {
      width: 30%;
    }
  }

  .popup-body {
    padding-bottom: 10vw;
    height: auto;
    min-height: 60vw;
    max-height: 80vw;
    overflow-y: auto;
    background: #fff;
  }

  .popup-item {
    height: 12.8vw;
    margin: 0 6.4vw;
    font-size: 4.27vw;

    &.active {
      color: color-primary;
    }
  }
}
</style>
